<template>
    <div>
        <form id="form_alunos" enctype="multipart/form-data">
          <input type="hidden" name="_method" :value="method">
            <div class="row">
                <div class="col-sm-12">
                    <h4>Dados Básicos</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <InputIconGroup typeInput="text" idInput="nome" iconInput="fa-info" labelInput="Nome">
                        &nbsp;
                    </InputIconGroup>
                </div>
                <div class="col-md-3">
                    <InputIconGroup typeInput="text" idInput="cpf" iconInput="fa-info" labelInput="CPF"
                                    :inputMask="['###.###.###-##']">
                        ###.###.###-##
                        &nbsp;
                    </InputIconGroup>
                </div>
                <div class="col-md-3">
                    <DateIconGroup idInput="data_nascimento" iconInput="fa-calendar"
                                   labelInput="Data de nascimento">
                        (AAAA-MM-DD)
                    </DateIconGroup>
                </div>
                <div class="col-md-6">
                    <InputIconGroup typeInput="email" idInput="email" iconInput="fa-envelope-o"
                                    labelInput="E-mail">
                        E-mail do aluno.
                    </InputIconGroup>
                </div>
                <div class="col-md-6">
                    <InputIconGroup idInput="telefone" iconInput="fa-phone" labelInput="Telefone/Celular"
                                    :inputMask="['(##) ####-####', '(##) # ####-####']">
                        (##) ####-#### | (##) # ####-####
                    </InputIconGroup>
                </div>
                <div class="col-md-12">
                  <InputIconGroup typeInput="text" idInput="obs" iconInput="fa-info"
                                  labelInput="Observação">
                    &nbsp;
                  </InputIconGroup>
                </div>

                <!--<div class="col-md-4">-->
                <!--<InputUploadGroup tituloUpload="Comprovante de endereço">-->

                <!--</InputUploadGroup>-->
                <!--</div>-->
                <!--<div class="col-md-4">-->
                <!--<InputUploadGroup tituloUpload="RG e CPF">-->

                <!--</InputUploadGroup>-->
                <!--</div>-->
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <h4>Endereço</h4>
                </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <InputIconGroup @change="searchCep($event)" typeInput="text" idInput="cep" iconInput="fa-info"
                                labelInput="CEP" :inputMask="['########']">
                  <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                     target="_blank">Consulte o CEP por endereço</a>
                </InputIconGroup>
              </div>
              <div class="col-md-4">
                <InputIconGroup typeInput="text" idInput="logradouro" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                  Logradouro
                </InputIconGroup>
              </div>
              <div class="col-md-3">
                <InputIconGroup typeInput="text" idInput="bairro" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                  Bairro
                </InputIconGroup>
              </div>
              <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="cidade" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                  Cidade
                </InputIconGroup>
              </div>
              <div class="col-md-1">
                <InputIconGroup typeInput="text" idInput="uf" iconInput="fa-info" labelInput=""
                                inputDisabled="disabled">
                  UF
                </InputIconGroup>
              </div>
              <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="numero" iconInput="fa-info"
                                labelInput="Número">
                  &nbsp;
                </InputIconGroup>
              </div>
              <div class="col-md-10">
                <InputIconGroup typeInput="text" idInput="complemento" iconInput="fa-info"
                                labelInput="Complemento">
                  &nbsp;
                </InputIconGroup>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div>
                  <h4>Já possui CNH?</h4>
                  <input @change="showCnh" type="checkbox">   Sim
                  <div v-if="alunoCnh">
                    <InputIconGroup typeInput="text" idInput="cnh" iconInput="fa-info" labelInput="CNH"></InputIconGroup>
                  </div>
                </div>
                <br>
                <div>
                  <h4>Selecione uma Categoria</h4>
                  <SelectIconGroup idInput="id_categoria" iconInput="fa-car" labelInput="Categoria" :optionsInput="optionsInputCat"
                  :optionSelected="optionSelectedCat"></SelectIconGroup>
                </div>
                <div>
                  <h4>Tipo</h4>
                  <SelectIconGroup idInput="id_tipo" iconInput="fa-info" labelInput="Tipo" :optionsInput="optionsInputType"
                  :optionSelected="optionSelectedType"></SelectIconGroup>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <label id="file-label-document" class="btn btn-micro btn-primary">
                        <input @change="fileName()" name="documento_pessoal" id="documento_pessoal" type="file"/>
                        <span style="font-weight: bold">{{ document_name }}</span>
                        &nbsp;<i v-if="document_check" class="fa fa-check" style="color: green"></i>
                    </label>
                  </div>
                  <!-- <div class="col-md-6">
                    <label id="file-label-photo" class="btn btn-micro btn-primary">
                        <input @change="photoName()" name="foto_pessoal" id="foto_pessoal" type="file"/>
                        <span style="font-weight: bold">{{ foto_name }}</span>
                        &nbsp;<i v-if="document_check" class="fa fa-check" style="color: green"></i>
                    </label>
                  </div> -->
                </div>
                <br>
                <br>
                <div>
                  <h4>Pagamento</h4>
                </div>
                <div>
                  <SelectIconGroup labelInput="$" idInput="id_pagamento" iconInput="fa-money"
                :optionsInput="optionsInputModel" :optionSelected="optionSelectedModel"></SelectIconGroup>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input @change="checkAll" type="checkbox" name="incluir-todas" id="all">   Incluir todas as taxas
                    <div v-for="taxa in taxas" :key="taxa.id_taxa" class="row">
                      <div v-if="!(taxa.id_taxa == 4)" class="col-md-12">
                        <input @change="check('taxa_'+taxa.id_taxa)" :value="taxa.taxas_valores[0].valor" type="checkbox"
                        :name="'taxa_'+taxa.id_taxa" :id="'taxa_'+taxa.id_taxa">    {{ taxa.taxa }}
                      </div>
                      <div v-if="taxa.id_taxa == 4" class="col-md-12">
                        <input @change="check('taxa_'+taxa.id_taxa)" :value="taxa.taxas_valores[0].valor" type="checkbox"
                        :name="'taxa_'+taxa.id_taxa" :id="'taxa_'+taxa.id_taxa" checked disabled>    {{ taxa.taxa }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card border-dark mb-3" style="max-width: 18rem;">
                      <div class="card-header" style="font-weight: bold;">Total</div>
                      <div class="card-body text-dark">
                        <h5 class="card-title" style="font-weight: bold;">R$ {{total}}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-12 text-center">
                    <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                    <button class="btn btn-primary" id="btn_salvar" type="button" @click="salvaInformacoes">
                        Salvar
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import AlunosController from './AlunosController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'
import InputUploadGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputUploadGroup'
import InputCheckboxGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputCheckboxGroup'

window._ = require('lodash')

export default {
  name: 'form-aluno',
  components: {
    InputUploadGroup,
    InputIconGroup,
    InputCheckboxGroup,
    DateIconGroup,
    SelectIconGroup
  },
  data () {
    return {
      method: 'post',
      optionsInputCat: [{
        id: '',
        value: 'Selecione uma categoria'
      }],
      optionSelectedCat: '',
      optionsInputType: [{
        id: '',
        value: 'Selecione um tipo'
      }],
      optionSelectedType: '',
      optionsInputModel: [{
        id: '',
        value: 'Selecione um modelo de pagamento'
      }],
      optionSelectedModel: '',
      total: 0.0,
      alunoCnh: false,
      taxas: [],
      document_name: 'Documentos',
      foto_name: 'Fotos',
      document_check: false,
      foto_check: false
    }
  },
  mounted () {
    let self = this

    AlunosController.getCategorias(function (data) {
      data.dados.map(function (value) {
        self.optionsInputCat.push({ id: value.id_categoria_cnh, value: value.categoria_cnh })
      })
    })

    AlunosController.getTipoCategorias(function (data) {
      data.dados.map(function (value) {
        self.optionsInputType.push({ id: value.id_tipo_categoria_cnh, value: value.tipo_categoria_cnh })
      })
    })

    AlunosController.getModelos(function (data) {
      data.dados.map(function (value) {
        self.optionsInputModel.push({ id: value.id_modelo_pagamento, value: value.modelo_pagamento })
      })
    })

    AlunosController.getTaxas(function (data) {
      data.dados.map(function (value) {
        self.taxas.push(value)
        if (value.id_taxa == 4) {
          self.total += parseFloat(value.taxas_valores[0].valor)
        }
      })
    })

    if (this.$route.params.idAluno) {
      this.method = 'patch'
      AlunosController.carregaFormularioDeEdicao(this.$route.params.idAluno)
    }
  },
  
  methods: {
    fileName () {
      let self = this
      var label = document.getElementById('file-label-document')
      var input = document.getElementById('documento_pessoal').value.split('\\')
      var file_name = input[input.length - 1]
      label.className = 'btn btn-micro btn-secondary'
      self.document_name = file_name
      self.document_check = true
    },
    // photoName(){
    //   let self = this
    //   var label = document.getElementById('file-label-photo');
    //   var input = document.getElementById('foto_pessoal').value.split("\\");
    //   var file_name = input[input.length - 1];
    //   label.className = "btn btn-micro btn-secondary";
    //   self.foto_name = file_name;
    //   self.foto_check = true;
    // },
    salvaInformacoes () {
      if (this.$route.params.idAluno) {
        AlunosController.update(this.$route.params.idAluno)
      } else {
        AlunosController.store()
      }
    },
    loadData () {
      this.table.load = true
      this.$http.get(this.urlCep + this.search + '/json/').then(this.callbackDataPaginate)
    },
    searchCep (e) {
      AlunosController.searchCep(e)
    },
    showCnh () {
      this.alunoCnh = !this.alunoCnh
      this.optionSelectedType = 2
    },
    checkAll () {
      let self = this
      var all = document.getElementById('all')

      if (all.checked == true) {
        for (var i = 0; i < self.taxas.length; i++) {
          var key = 'taxa_' + self.taxas[i].id_taxa
          var doc = document.getElementById(key)
          if (doc.checked == true) {
            continue
          } else if (doc.id == 'taxa_4') {
            continue
          } else {
            doc.checked = true
            this.check(key)
          }
        }
      } else if (all.checked == false) {
        for (var i = 0; i < self.taxas.length; i++) {
          var key = 'taxa_' + self.taxas[i].id_taxa
          var doc = document.getElementById(key)
          if (doc.checked == false) {
            continue
          } else if (doc.id == 'taxa_4') {
            continue
          } else {
            doc.checked = false
            this.check(key)
          }
        }
      }
    },
    check (key) {
      let self = this
      var doc = document.getElementById(key)
      var val = 0.0

      if (doc.checked == true) {
        val += parseFloat(doc.value)
      } else if (doc.checked == false) {
        val -= parseFloat(doc.value)
      }

      self.total += parseFloat(val)
      self.total = parseFloat(self.total.toFixed(2))
    }
  }
}
</script>

<style scoped>
  input[type="file"] {
    display: none;
  }
</style>
